<template>
  <div>
    <yxt-drawer
      :title="title || $t('pc_gwnl_eval_importEmployeeEvaluationScores')"
      size="640px"
      :visible.sync="visibleDrawer"
      :before-close="cancleMessageBox"
      @close="close"
    >
      <section class="yxt-upload-explain__section reportsProjectSelectModel">
        <ul class="yxt-upload-explain-list">
          <li>
            <span class="yxt-upload-explain-num color-gray-8">1</span>
            <div
              class="standard-size-14 color-gray-10 yxt-upload-explain-title"
            >
              {{ $t('pc_gwnl_web_trainingModel') }}
            </div>
            <div class="yxt-upload-explain-summary color-gray-8">
              {{ peopleName }}
            </div>
          </li>
          <li>
            <span class="yxt-upload-explain-num color-gray-8">2</span>
            <div
              class="standard-size-14 color-gray-10 yxt-upload-explain-title"
            >
              {{
                $t('pc_gwnl_import_downloadTemplate', {
                  btnName: $t('pc_gwnl_import_download')
                })
              }}
            </div>
            <div class="yxt-upload-explain-summary color-gray-8">
              <span class="color-red-6">{{
                $t('pc_gwnl_import_readInstructions')
              }}</span>
              {{ $t('pc_gwnl_import_fillRequired') }}
            </div>
            <yxt-button
              class="mt16"
              type="primary"
              :loading="btnDisabled"
              @click="downloadExcel"
            >
              {{ $t('pc_gwnl_import_download') }}
            </yxt-button>
          </li>
          <li>
            <span class="yxt-upload-explain-num color-gray-8">3</span>
            <div
              class="standard-size-14 color-gray-10 yxt-upload-explain-title"
            >
              {{ $t('pc_gwnl_import_instruction1') }}
            </div>
            <div class="yxt-upload-explain-summary color-gray-8">
              {{ $t('pc_gwnl_import_instruction2') }}
            </div>
          </li>
        </ul>
        <!--上传-->
        <div v-if="step === 1" class="yxt-upload-container">
          <yxtbiz-upload
            ref="bizUpload"
            source="501"
            config-key="AttachConfigKey"
            module-name="attach"
            function-name="import"
            :app-code="module"
            :before-upload="beforeUpload"
            :on-progress="onProgress"
            :on-uploaded="onUploaded"
            :on-error="onError"
            :drag="true"
            filters=".xlsx,.xls"
            :files-filter="filesFilter"
          >
            <div slot="tip">
              {{ $t('pc_gwnl_import_supportExtension') }}
            </div>
          </yxtbiz-upload>
        </div>
        <div v-if="step === 3" class="yxt-upload-container">
          <ul class="yxt-upload-item-list">
            <li class="is-completed color-primary-6">
              <span class="yxt-upload-status" />
              <yxt-row
                type="flex"
                align="middle"
                class="color-gray-10 yxt-upload-item-title"
              >
                {{ file.name }}
                <yxt-button type="primary" @click="reset">
                  {{
                    successCount > 0 && failedCount > 0
                      ? this.$t('cc_btn_continueupload')
                      : this.$t('pc_gwnl_import_reupload')
                  }}
                </yxt-button>
              </yxt-row>
              <yxt-row
                type="flex"
                align="middle"
                class="standard-size-12 lh20 mt4"
              >
                <yxt-link :underline="false" type="success">
                  <i class="yxt-icon-success" />
                </yxt-link>
                <span class="color-gray-8 ml3">{{
                  $t('pc_gwnl_import_uploadSuccess')
                }}</span>
              </yxt-row>
            </li>
            <li v-if="checking" class="is-active color-primary-6">
              <span class="yxt-upload-status" />
              <div class="color-gray-10 yxt-upload-item-title">
                {{ $t('pc_gwnl_import_msg_checkingFormat') }}
              </div>
              <yxt-row
                type="flex"
                align="middle"
                class="standard-size-12 lh20 mt4"
              >
                <span class="color-gray-8 ml16">{{
                  $t('pc_gwnl_import_checking')
                }}</span>
              </yxt-row>
            </li>
            <li
              v-if="failedCount > 0 && successCount === 0"
              class="is-active color-primary-6"
            >
              <span class="yxt-upload-status" />
              <yxt-row
                type="flex"
                align="middle"
                class="color-gray-10 yxt-upload-item-title"
              >
                {{ $t('pc_gwnl_import_abnormalFormat') }}
              </yxt-row>
              <yxt-row
                type="flex"
                align="middle"
                class="standard-size-12 lh20 mt4"
              >
                <yxt-link :underline="false" type="warning">
                  <i class="yxt-icon-warning" />
                </yxt-link>
                <span class="color-gray-8 ml3">{{
                  $t('pc_gwnl_import_checkFailed')
                }}</span>
                <yxt-link
                  class="standard-size-12 ml8"
                  type="primary"
                  :underline="false"
                  @click="downloadError"
                >
                  {{ $t('pc_gwnl_import_downloadErrDes') }}
                </yxt-link>
              </yxt-row>
            </li>
            <li v-if="showError" class="is-active color-primary-6">
              <span class="yxt-upload-status" />
              <yxt-row
                type="flex"
                align="middle"
                class="color-gray-10 yxt-upload-item-title"
              >
                {{ $t('pc_gwnl_import_selectAgain') }}
              </yxt-row>
              <yxt-row
                type="flex"
                align="middle"
                class="standard-size-12 lh20 mt4"
              >
                <yxt-link :underline="false" type="danger">
                  <i class="yxt-icon-error" />
                </yxt-link>
                <span class="color-gray-8 ml3">{{
                  errorMsg || $t('pc_gwnl_import_checkFail')
                }}</span>
              </yxt-row>
            </li>

            <li
              v-if="!checking && successCount > 0"
              class="is-completed color-primary-6"
            >
              <span class="yxt-upload-status" />
              <yxt-row
                type="flex"
                align="middle"
                class="color-gray-10 yxt-upload-item-title"
              >
                {{ $t('pc_gwnl_import_checkCompleted') }}
              </yxt-row>
              <yxt-row
                type="flex"
                align="middle"
                class="standard-size-12 lh20 mt4"
              >
                <yxt-link :underline="false" type="success">
                  <i class="yxt-icon-success" />
                </yxt-link>
                <span class="color-gray-8 ml3">{{
                  $t('pc_gwnl_import_checkPassed')
                }}</span>
              </yxt-row>
            </li>
            <li
              v-if="successCount > 0 && failedCount === 0"
              class="is-active color-primary-6"
            >
              <span class="yxt-upload-status" />
              <yxt-row
                type="flex"
                align="middle"
                class="color-gray-10 yxt-upload-item-title"
              >
                {{ $t('pc_gwnl_import_importSuccessCount1') }}
                <yxt-link
                  class="standard-size-14"
                  :underline="false"
                  type="success"
                >
                  {{ successCount }}
                </yxt-link>
                {{ $t('pc_gwnl_import_importSuccessCount2') }}
              </yxt-row>
              <yxt-row
                type="flex"
                align="middle"
                class="standard-size-12 lh20 mt4"
              >
                <yxt-link :underline="false" type="success">
                  <i class="yxt-icon-success" />
                </yxt-link>
                <span class="color-gray-8 ml3">{{
                  $t('pc_gwnl_import_importSuccess')
                }}</span>
              </yxt-row>
            </li>
            <li
              v-if="successCount > 0 && failedCount > 0"
              class="is-active color-primary-6"
            >
              <span class="yxt-upload-status" />
              <yxt-row
                type="flex"
                align="middle"
                class="color-gray-10 yxt-upload-item-title"
              >
                <yxt-link
                  class="standard-size-14"
                  :underline="false"
                  type="success"
                >
                  {{ successCount }}
                </yxt-link>
                {{ $t('pc_gwnl_import_importSuccessFailed1') }}
                <yxt-link
                  class="standard-size-14"
                  :underline="false"
                  type="danger"
                >
                  {{ failedCount }}
                </yxt-link>
                {{ $t('pc_gwnl_import_importSuccessFailed2') }}
              </yxt-row>
              <yxt-row
                type="flex"
                align="middle"
                class="standard-size-12 lh20 mt4"
              >
                <yxt-link :underline="false" type="success">
                  <i class="yxt-icon-success" />
                </yxt-link>
                <span class="color-gray-8 ml3">{{
                  $t('pc_gwnl_import_importCompleted')
                }}</span>
                <yxt-link
                  class="standard-size-12 ml8"
                  type="primary"
                  :underline="false"
                  @click="downloadError"
                >
                  {{ $t('pc_gwnl_import_btn_downloadfaileddata') }}
                </yxt-link>
              </yxt-row>
            </li>

            <li v-if="successCount === 0" class="color-primary-6">
              <span class="yxt-upload-status" />
              <div class="color-gray-8 yxt-upload-item-title">
                {{ $t('pc_gwnl_import_downloadData') }}
              </div>
            </li>
          </ul>
        </div>
      </section>
    </yxt-drawer>
  </div>
</template>
<script>
import {
  reportsProjectPeopleTemplate,
  // getModelNameByIds,
  reportsProjectPeopleImprot,
  getModelIdsByEvalId
} from './service.js';
export default {
  name: 'YxtbizEvalImportEvalScore',
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    evaluationId: {
      type: String,
      default: ''
    },
    source: {
      // (value = "来源类型（0-单独安排；1-测训项目安排；2-人才盘点安排, 3-代运营, 4-岗位地图安排，5-层级地图 6-第三方导入，7-档案)")
      type: Number,
      required: true
    },
    evalType: {
      // 测训项目需要区分前后测。测评类型 1:前测测评，2:后测测评 ,3:不区分前后测
      type: Number
    },
    projectId: {
      type: String,
      default: ''
    },
    // modelIds: {
    //   type: Array,
    //   default: []
    // },
    title: {
      type: String,
      default: ''
    },
    module: {
      // 外部可传入的模块名 同app-code
      type: String,
      default: 'evalpc'
    }
  },
  data() {
    return {
      models: [],
      btnDisabled: false,
      visibleDrawer: false,
      file: {},
      value: true,
      ruleForm: {
        type: 1
      },
      step: 1,
      checking: false, // 检查中
      showError: false, // 非正常数据模板文件，请重新选择文件！检查失败
      failedCount: 0, // 失败n条
      successCount: 0, // 成功导入n条数据
      filePath: '', // 异常说明链接
      errorMsg: ''
    };
  },
  computed: {
    peopleName() {
      if (this.models && this.models.length) {
        let namelist = this.models.map(item => item.name);
        console.log(namelist, 'x1111......');
        let str = '';
        if (namelist.length > 2) {
          str = `${namelist.join('，')}`;
        } else {
          str = `${namelist.join('，')}`;
        }
        return str;
      } else {
        return '';
      }
    }
  },
  watch: {
    evaluationId: {
      immediate: false,
      handler(val) {
        this.getModels(val);
      }
    },
    visible: {
      immediate: false,
      handler(val) {
        console.log(val, '...............');
        if (val) {
          this.getModels();
          if (!this.validProps()) {
            this.$emit('update:visible', false);
            return;
          }
        }
        this.visibleDrawer = val;
      }
    },
    visibleDrawer(val) {
      this.$emit('update:visible', val);
    }
  },
  created() {},
  mounted() {},
  methods: {
    // getModelNameByIds(ids) {
    //   console.log(ids, 'ids......');
    //   if (!ids || !ids.length) return;
    //   getModelNameByIds(ids)
    //     .then(res => {
    //       if (res && res.length) {
    //         this.models = res.map((item, index) => {
    //           return {
    //             id: item.id,
    //             name: item.name || index
    //           };
    //         });
    //       } else {
    //         this.$message.warning('no get modelID');
    //       }
    //     })
    //     .catch(e => {
    //       this.$message.warning(e.message || 'get modelID error');
    //       console.log(e);
    //     });
    // },
    getModels(id) {
      getModelIdsByEvalId(id || this.evaluationId)
        .then(res => {
          if (res && res.models && res.models.length) {
            this.models = res.models.map((item, index) => {
              return {
                id: item.modelId,
                name: item.modelName
              };
            });
          } else {
            this.$message.error('no modelId');
          }
          console.log(res, 'xxx');
        })
        .catch(e => {
          console.log(e);
          this.$message.error(e.message || 'get modelId failed');
        });
    },
    validProps() {
      if (!this.evaluationId) {
        this.$message.warning('测评id不能为空');
        return;
      }
      if (!this.source) {
        this.$message.warning('source不能为空');
        return;
      }

      if (this.source !== 6 && !this.projectId) {
        this.$message.warning('project 不能为空');
        return;
      }

      if (this.source === 1 && !this.evalType) {
        this.$message.warning('evalType 不能为空');
        return;
      }
      return true;
    },
    close() {
      this.reset();
      this.$emit('close');
    },
    cancleMessageBox(done) {
      done();
    },
    // 重新上传
    reset() {
      this.file = {};
      this.value = true;
      this.checking = false;
      this.showError = false;
      this.failedCount = 0;
      this.successCount = 0;
      this.filePath = '';
      this.step = 1;
      this.errorMsg = '';
    },
    throttle(method) {
      clearTimeout(method.tId);
      method.tId = setTimeout(() => {
        method();
      }, 1000);
    },
    // 下载异常说明
    downloadError() {
      if (!this.clicked) {
        window.location.href = this.filePath;
      } else {
        this.$message.warning(this.$t('pc_gwnl_import_downloading'));
      }
      this.clicked = true;
      this.throttle(() => {
        this.clicked = false;
      });
    },
    importMethods(file) {
      let formdata = new FormData();
      formdata.append('fileId', file.id);

      let data = {
        // fileUrl: formdata,
        evaluationId: this.evaluationId || '',
        source: this.source,
        evalType: this.evalType,
        projectId: this.projectId
      };

      return reportsProjectPeopleImprot(data, formdata);
    },
    async handleImport(file) {
      this.step = 3;
      // 正在检验数据格式
      // 检查中...
      this.checking = true;
      this.errorMsg = '';
      this.importMethods(file)
        .then(res => {
          this.checking = false;
          if (res.failedCount > 0) {
            this.filePath = res.filePath;
          }
          this.successCount = res.successCount;
          this.failedCount = res.failedCount;
          if (res.totalCount === 0) {
            this.checking = false;
            this.showError = true;
          }
          if (this.successCount > 0 && this.failedCount === 0) {
            this.visibleDrawer = false;
            this.$emit('success');
          }
        })
        .catch(err => {
          if (
            err &&
            err.error &&
            err.error.key === 'apis.skill.import.excel.sheetName.error'
          ) {
            this.errorMsg = this.$t('pc_gwnl_sheetname_error').d('sheet名称不符，请核实');
          } else {
            this.$talentHandleError(err);
          }
          // 非正常数据模板文件，请重新选择文件！
          // 检查失败
          this.checking = false;
          this.showError = true;
        });
    },
    downloadExcel() {
      // this.$emit('getTemplate')
      this.getTemplate();
    },
    getTemplate() {
      this.btnDisabled = true;
      console.log(this.evaluationId, 'x.......');
      reportsProjectPeopleTemplate({evaId: this.evaluationId})
        .then(res => {
          if (res) {
            window.location.href = res.fileUrl;
            this.btnDisabled = false;
          }
        })
        .catch(err => {
          this.$talentHandleError(err);
          this.btnDisabled = false;
        });
    },
    onError(e) {
      if (e === 'forbidden') {
        this.$message.warning(this.$t('pc_gwnl_import_wrongFormat'));
      }
    },
    httpRequest(v) {
      this.handleImport(v.file);
    },
    onSuccess(response, file) {},
    onUploaded(file) {
      // 上传文件成功事件
      this.handleImport(file);
    },
    onProgress(file, progress, event) {
      // 上传进度事件，回调参数（file：上传的文件，progress：已上传比例，event：进度事件参数）
      const f = this.getFile(file.uuid);
      if (f) {
        f.percentage = progress.toFixed(2) * 100;
      }
    },
    getFile(uuid) {
      if (this.file.uuid === uuid) {
        return this.file;
      }
    },
    beforeUpload(file) {
      let Xls = file.name.split('.');
      if (Xls[Xls.length - 1] === 'xls' || Xls[Xls.length - 1] === 'xlsx') {
        this.file = {
          uuid: file.uuid,
          percentage: 0
        };
        if (Xls[0].length > 13) {
          this.file.name = Xls[0].slice(0, 13) + '...' + Xls[Xls.length - 1];
        } else {
          this.file.name = file.name;
        }
        this.uploadShow = true;
        this.uploading = true;
      } else {
        this.$message.warning(this.$t('pc_gwnl_import_wrongFormat'));
        return false;
      }
    },
    filesFilter(files) {
      if (files[0] && !/.xlsx?$/.test(files[0].name)) {
        this.$message.warning(this.$t('pc_gwnl_import_wrongFormat'));
        return [];
      }
      return files;
    }
  }
};
</script>
<style lang="scss" scoped>
.yxt-upload-explain__section {
  .card {
    display: inline-block;
    flex: 1;
    box-sizing: border-box;
    height: 80px;
    padding: 10px 0;
    line-height: 22px;
    text-align: center;
    background: rgba(255, 255, 255, 1);
    border-style: solid;
    border-width: 1px;
    border-radius: 4px;
    cursor: pointer;

    &.active {
      background: rgba(247, 250, 255, 1);
    }
  }

  .content {
    box-sizing: border-box;
    width: 328px;
    padding: 12px 16px;
    color: rgba(89, 89, 89, 1);
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    background: rgba(250, 250, 250, 1);
  }

  /deep/ .yxt-link {
    .yxt-link--inner {
      font-size: 12px;
      line-height: 20px;
    }

    &.standard-size-14 .yxt-link--inner {
      font-size: 14px;
      line-height: 22px;
    }
  }
}

.yxt-upload-item-list li.is-active .yxt-upload-status {
  top: 6px;
  left: 0;
  width: 10px;
  height: 10px;
}

.yxt-upload-item-list .yxt-upload-item-title {
  font-weight: 400;
}

.yxt-upload-explain-list .yxt-upload-explain-title {
  font-weight: 500;
}

.reportsProjectSelectModel {
  .yxt-upload-explain-list {
    li {
      &:first-of-type {
        padding-bottom: 80px;
      }
    }
  }
}
</style>
